import api from "@/services/api"

export class SupportApi {
  public sendSupport = (data: FormData) =>
    api.post("/api/v1/support", data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
}
